import AuthToken from "utils/localStorage/AuthToken";
import CoursesList from "utils/localStorage/CoursesList";
import UserName from "utils/localStorage/UserName";
import syncPreferredLanguage from "i18n/syncPreferredLanguage";

const handleSuccessfulAuth = (auth_token, user, courses = []) => {
  AuthToken.write(auth_token);
  CoursesList.write(courses);
  UserName.write(user.name);
  syncPreferredLanguage(user.preferred_language);
};

export default handleSuccessfulAuth;
